import { LitElement, css } from "lit-element";
import { html } from "lit-html";
import PubSub from "pubsub-js";
import "@ui5/webcomponents/dist/Button.js";
import "@ui5/webcomponents/dist/Dialog.js";
import "@ui5/webcomponents/dist/Panel.js";
import { storeInstance } from "../store";

/**
 * @property {Object} errorData - contains short/long descriptions of the error
 * @property {Boolean} dialogOpened - controls whether dialog is mounted to DOM
 */
export class KbDialogError extends LitElement {
  static properties = {
    errorData: { type: Object },
    dialogOpened: { state: true, type: Boolean },
  };

  constructor() {
    super();
    this.dialogOpened = false;
  }

  connectedCallback() {
    super.connectedCallback();
    this.subscription = storeInstance.subscribe((state) => {
          this.stateChange(state);
        });
    this.state = storeInstance.state;
    let token = PubSub.subscribe("error.serverError", this.getError.bind(this));
    if (!token) console.log("An error occurred");
  }

  stateChange(state) {
    this.state = state
  }

  getError(msg, data) {
    this.errorData = data;
    this.show();
  }

  show() {
    this.dialogOpened = true;
  }

  // Remove dialog from DOM
  reloadPage() {
    let pathname = `/kb/${this.state.langCode}`
    var compRedir = encodeURIComponent("?redir=" + pathname);     
    //var compRedir = encodeURIComponent("?redir=" + window.location);
    var redir = encodeURI("/kb/jrest/loginReaderIDP" + compRedir);
    window.location =
      "/lwa/jrest/Auth/IDPLogin?appId=kb&idpclient=choose&redirecturi=" + redir;
  }

  dialogTemplate() {
    return html` <style>
        .long-description {
          padding: 2rem;
          overflow-wrap: anywhere;
          background-color: wheat;
          max-height: 9rem;
          overflow-y: scroll;
          max-width: 54rem;
          box-sizing: border-box;
          width: 100%;
          margin: 0;
          transition: all 0.5s ease-in-out;
        }

        .short-description {
          margin-bottom: 0;
        }

        .icons {
          color: red;
        }

        .content-container {
          margin: 0 0 1rem;
        }

        .heading {
          margin-top: 0;
        }

        ui5-panel {
          --sapGroup_Title_FontSize: 1rem;
        }
      </style>
      <section>
        <h2 class="heading">
          Server Error
          <iron-icon class="icons" icon="icons:error-outline"></iron-icon>
        </h2>
        <div class="content-container">
          <p class="short-description">
            ${this.errorData?.shortDesc
              ? this.errorData.shortDesc
              : "An error occured."}
          </p>
          <ui5-panel header-text="See long description">
            <p class="long-description">
              ${this.errorData?.detail
                ? this.errorData.detail
                : "No further description."}
            </p>
          </ui5-panel>
        </div>
        <footer>
          <ui5-button theme="primary" @click=${this.reloadPage}
            >Back to home</ui5-button
          >
        </footer>
      </section>`;
  }

  render() {
    return html`
      <ui5-dialog
        header-text="Server Error"
        state="Error"
        ?open=${this.dialogOpened}
      >
        ${this.dialogTemplate()}
      </ui5-dialog>
    `;
  }

  static styles = css`
    vaadin-dialog-overlay {
      width: 25rem;
    }
  `;
}

customElements.define("kb-dialog-error", KbDialogError);
